<template>
  <div class="component-ranking-item flex-middle" v-if="index > 2">
    <div class="flex-row align-center flex-between">
      <div class="item item-num flex-middle">
        <div>{{ index + 1 }}</div>
      </div>
      <div class="item item-header flex-row">
        <div class="flex-middle">
          <div class="header">
            <img class="header-img" :src="item.avatar" />
          </div>
        </div>
      </div>
      <template v-if="!item.isXWYD">
        <div class="item item-nick flex-column">
          <div class="flex-row align-center anchor">
            <div class="nickname">{{ item.nickname }}</div>
            <img v-if="item.is_live == 1" class="starting" @click="joinRoom" src="./img/starting.gif" />
          </div>
          <div class="flex-row">
            <div class="flex-row flex-middle star">
              <img :src="levelImgArr[item.level]" />
            </div>
            <div class="noble" v-if="item.noble_src">
              <img class="top-tip" :src="item.noble_src" />
            </div>
          </div>
        </div>
      </template>
      <template v-else>
        <div class="item item-nick flex-column" style="top: 0rem">
          <div class="flex-row align-center anchor">
            <div class="nickname" style="color: #bbbbbb; font-weight: 400">{{ item.nickname }}</div>
          </div>
        </div>
      </template>
      <div class="item item-stat flex-middle" :class="type !== 1 ? 'text_right' : ''">
        <template v-if="!item.isXWYD">
          <div class="flex-column">
            <div>{{ item.stat }}</div>
            <div style="color: #999999; line-height: 0.3rem">{{ item.stat_label }}</div>
          </div>
        </template>
        <template v-else>
          <div class="flex-column">
            <div style="color: #bbbbbb; line-height: 0.3rem">--</div>
          </div>
        </template>
      </div>
      <div class="item item-follow flex-middle" v-if="needFocusBtn">
        <template v-if="!item.isXWYD">
          <div v-if="item.is_follow == 1" class="flex-middle focus-yes focus" @click="follow">
            <img src="./img/focus-yes.png" />
            <div>已关注</div>
          </div>
          <div v-else class="flex-middle focus-no focus" @mouseover="toOver" @mouseout="toOut" @click="follow">
            <img :src="isHover ? require('./img/focus-no-b.png') : require('./img/focus-no.png')" />
            <div>关注</div>
          </div>
        </template>
        <template v-else>
          <div class="flex-column">
            <div style="color: #bbbbbb; line-height: 0.3rem">--</div>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>


<script>
import { post } from "@/util/http";
export default {
  props: {
    type: {
      type: Number,
      default: 0,
    },
    index: {
      type: Number,
      default: 0,
    },
    item: {
      type: Object,
      default() {
        return {
          header: require("./img/head.png"),
        };
      },
    },
    needFocusBtn: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      numImgArr: [require("./img/n-4.png"), require("./img/n-5.png"), require("./img/n-6.png")],
      levelImgArr: [
        require("./img/lv1.png"),
        require("./img/lv1.png"),
        require("./img/lv2.png"),
        require("./img/lv3.png"),
        require("./img/lv4.png"),
        require("./img/lv5.png"),
        require("./img/lv6.png"),
        require("./img/lv7.png"),
        require("./img/lv8.png"),
        require("./img/lv9.png"),
        require("./img/lv10.png"),
        require("./img/lv11.png"),
        require("./img/lv12.png"),
        require("./img/lv13.png"),
        require("./img/lv14.png"),
        require("./img/lv15.png"),
        require("./img/lv16.png"),
        require("./img/lv17.png"),
        require("./img/lv18.png"),
        require("./img/lv19.png"),
        require("./img/lv20.png"),
        require("./img/lv21.png"),
      ],
      isHover: false,
    };
  },
  methods: {
    follow() {
      this.$emit("tofollow", this.item);
    },

    joinRoom() {
      if (this.item && this.item.uid) {
        this.$router.push({
          // path: `/liveMatchesTwo/${this.type === "live" ? this.live.anchorid : this.live.id}`,
          path: `/liveMatchesTwo/${this.item.uid}`,
        });
      }
    },

    toOver() {
      this.isHover = true;
    },

    toOut() {
      this.isHover = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.component-ranking-item {
  height: 0.8rem;
  border-bottom: 1px solid #f0f0f0;
  padding-right: 0.1rem;
  color: #333333;
  & > div {
    flex: 1;
  }
  .item-num {
    flex-shrink: 0;
    width: 0.4rem;
    text-align: center;
    img {
      width: 0.5rem;
    }
  }
  .item-header {
    width: 12%;
    & > div {
      position: relative;
    }
    img.header-noble {
      position: absolute;
      top: -0.05rem;
      left: -0.05rem;
      width: 0.3rem;
      height: 0.3rem;
      z-index: 10;
    }
    .header {
      // padding : .01rem;
      // background : linear-gradient(90deg, #29F19C 0%, #02A1F9 100%);
      overflow: hidden;
      border-radius: 50%;
      position: relative;
      img.header-img {
        height: 0.48rem;
        width: 0.48rem;
      }
    }
  }

  .item-nick {
    position: relative;
    flex: 1;
    top: 0.05rem;
    .anchor {
      .nickname {
        padding-left: 0.1rem;
        line-height: 0.2rem;
        white-space: nowrap;
        font-weight: 600;
        margin-right: 0.02rem;
      }
      img {
        height: 0.2rem;
      }
      .starting {
        cursor: pointer;
      }
    }
    .noble {
      margin-left: 0.04rem;
      img {
        height: 0.24rem;
        margin-top: 0.01rem;
      }
    }
    .star {
      position: relative;
      img {
        height: 0.3rem;
      }
    }
  }

  .item-stat {
    width: 24%;
  }
  .text_right {
    width: auto;
    text-align: right;
  }
  .item-follow {
    width: 20%;
  }
  .focus {
    width: 0.7rem;
    border-radius: 0.5rem;
    padding: 0.05rem 0.05rem;
    cursor: pointer;
    img {
      width: 0.1rem;
      height: 0.1rem;
      margin-right: 0.05rem;
    }
    &.focus-yes {
      color: #999999;
      border: 1.2069px solid #dbdbdb;
    }
    &.focus-no {
      // background: linear-gradient(90deg, #29F19C 0%, #02A1F9 100%);
      border: 1.2069px solid #02a8a2;
      font-size: 0.12rem;
      color: #02a8a2;
    }
  }
  .focus-no:hover {
    background: linear-gradient(90deg, #29f19c 0%, #02a1f9 100%);
    color: #ffffff;
    border: 0rem;
  }
}
</style>